var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"image",style:('background-image: url(' + _vm.selectedImage + ')')}),_vm._v(" "),_c('div',{ref:"controls",staticClass:"controls"},[_c('div',{staticClass:"thumbnails"},_vm._l((_vm.images),function(image,index){return _c('div',{key:image,ref:'thumbnail' + index,refInFor:true,style:(_vm.thumbnailStyle(index)),on:{"click":function($event){_vm.selectThumbnail(index)}}})}),0)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a8c6b9e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PfxCarousel.vue
// module id = J56d
// module chunks = 1